import Globals from "../../components/globals";

export const carcassmodel = {
    TYPE_OUTER: "outer",
    TYPE_INNER: "inner",
    TYPE_HEADER: "header",
    TYPE_FOOTER: "footer",
    TYPE_DIVIDER: "divider",
    TYPE_PITCHY: "pitchy",
    TYPE_PITCHX: "pitchx",
    TYPE_BASEBOX: "basebox",
    TYPE_ELEMENT: "element",

    PROPERTY_X: "x",
    PROPERTY_Y: "x",
    PROPERTY_WIDTH: "width",
    PROPERTY_HEIGHT: "height",

    PLANO_TILE: 1,
    PLANO_WALL: 2,
    PLANO_CATEGORY_SYSTEM: 3,

    getType(id) {
        let type = id.substr(0, id.indexOf("_"));
        return type;
    },

    element(parent) {
        let UUID = Globals.UUID();
        return {
            id: this.TYPE_DIVIDER + "_" + UUID,
            name: null,
            x: 0,
            y: 0,
            width: 10,
            height: 0,
            xOrigin: 0,
            yOrigin: 0,
            parent: parent,
            _type: this.TYPE_DIVIDER,
            _color: "#cfdb75"
        };
    },

    workspace() {
        return {
            id: "workspace_rect",
            height: 2000,
            width: 2000,
            x: 0,
            y: 0,
            xOrigin: 0,
            yOrigin: 0,
            _type: "workspace",
            _color: "#FFFFFF"
        };
    },

    outer(parent = null) {
        return {
            id: this.TYPE_OUTER + "_rect",
            x: 0,
            y: 100,
            height: 0,
            width: 0,
            xOrigin: 0,
            yOrigin: 0,
            parent: parent,
            _type: this.TYPE_OUTER,
            _color: "#56c0e0"
        };
    },

    inner(parent = null) {
        return {
            id: this.TYPE_INNER + "_rect",
            height: 0,
            width: 0,
            x: 0,
            y: 0,
            xOrigin: 0,
            yOrigin: 0,
            parent: parent,
            _type: this.TYPE_INNER,
            _color: "#3d89cc"
        };
    },

    header(parent = null) {
        return {
            id: this.TYPE_HEADER + "_rect",
            height: 0,
            width: 0,
            x: 0,
            y: 0,
            xOrigin: 0,
            yOrigin: 0,
            parent: parent,
            _type: this.TYPE_HEADER,
            _color: "#57B856"
        };
    },

    footer(parent = null) {
        return {
            id: this.TYPE_FOOTER + "_rect",
            height: 0,
            width: 0,
            x: 0,
            y: 0,
            xOrigin: 0,
            yOrigin: 0,
            parent: parent,
            _type: this.TYPE_FOOTER,
            _color: "#f1ad43"
        };
    },

    divider(parent = null) {
        let UUID = Globals.UUID();
        return {
            id: this.TYPE_DIVIDER + "_" + UUID,
            x: 0,
            y: 0,
            width: 10,
            height: 0,
            xOrigin: 0,
            yOrigin: 0,
            parent: parent,
            _type: this.TYPE_DIVIDER,
            _color: "#db524a"
        };
    },

    pitchX(parent) {
        let UUID = Globals.UUID();
        return {
            id: this.TYPE_PITCHX + "_" + UUID,
            x: 0,
            y: 0,
            xOrigin: 0,
            xEnd: 0,
            repeat: 0,
            parent: parent,
            _type: this.TYPE_PITCHX,
            constant: true
        };
    },

    pitchY(parent) {
        let UUID = Globals.UUID();
        return {
            id: this.TYPE_PITCHX + "_" + UUID,
            x: 0,
            y: 0,
            yEnd: 0,
            yOrigin: 0,
            repeat: 0,
            parent: parent,
            _type: this.TYPE_PITCHY,
            constant: true
        };
    },

    baseBox(parent) {
        let UUID = Globals.UUID();
        return {
            id: this.TYPE_BASEBOX + "_" + UUID,
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            xOrigin: 0,
            yOrigin: 0,
            parent: parent,
            _type: this.TYPE_BASEBOX,
            _color: "#ec7dff"
        };
    },

    pitch() {
        return {
            x: 0,
            y: 0,
            _type: "pitch"
        };
    }
};



// WEBPACK FOOTER //
// ./src/store/planonext/carcassmodel.js